import { Modal, Form, IFormContext, arraySearch } from 'rewire-ui';
import { MessageInput, MessageLevels } from '../DataTypes';
import DataMutations from '../graphql/Mutations';
import { notifications } from '../ui/Notifications';
import { capitalCase } from 'change-case';

export class CommentDialogModel extends Modal {
  form: Form;
  comments: MessageInput[];

  constructor() {
    super('Add Comment');

    const levelSearcher = arraySearch(Object.values(MessageLevels), (item: any) => (item && !Array.isArray(item) && capitalCase(item)) || '');

    this.form = Form.create((form: IFormContext) => ({
      text: form.string().label('Comment').validators('required').placeholder('enter comment').autoFocus(),
      level: form.select(levelSearcher).label('Level').placeholder('enter message level').validators('required'),
    }));
    this.action('cancel')
      .action('save', this.submit, { variant: 'contained', type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load(comments: MessageInput[]) {
    this.reset();
    this.comments = comments;
    const level = comments.find(c => !!c.level)?.level;
    this.form.value = { text: undefined, level: level };
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const messageInputs = [] as MessageInput[];
    for (const comment of this.comments) {
      const messageInput: MessageInput = {
        ...comment,
        text: this.form.field.text.value,
        level: this.form.field.level.value,
      };
      messageInputs.push(messageInput);
    }

    const result = await DataMutations.insertMessages('', messageInputs);

    const isMultiple = messageInputs.length > 1;
    if (result?.[0]) {
      const prefix = isMultiple ? 'Comments were' : 'Comment was';
      notifications.success(`${prefix} successfully added`);
      return true;
    }

    notifications.error(`Comment${isMultiple ? 's' : ''} addition Failed`);
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const commentDialogModel = new CommentDialogModel();
export default commentDialogModel;
